/** Iter 632 — customer wizard · fatal error card (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import { Loader2, RefreshCw } from "lucide-react";

export default function ErrorCard({ w }) {
  const { fatal, setFatal, startSession, creating } = w;
  return (
    <div className="rounded-2xl bg-red-50 border border-red-200 p-5 text-center" data-testid="engage-session-error">
      <p className="text-sm text-red-700">{fatal}</p>
      {/* Iter-422 — never a dead-end: retry re-creates the session
          from the scanned QR (fresh-scan-creates on the backend). */}
      <button
        type="button"
        data-testid="engage-error-retry"
        onClick={() => {
          setFatal(null);
          startSession(false);
        }}
        disabled={creating}
        className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-bold px-6 py-2.5 transition-colors disabled:opacity-60"
      >
        {creating ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
        Try again
      </button>
    </div>
  );
}
